import { StatRing } from './StatRing';
import { summarizeScanCompliance } from './scanCompliance';

interface ScanComplianceRingProps {
    lateCount: number;
    onTimeCount: number;
}

function ScanComplianceRing({ lateCount, onTimeCount }: ScanComplianceRingProps) {
    const summary = summarizeScanCompliance(lateCount, onTimeCount);
    return (
        <StatRing
            pct={summary.onTimePct}
            color={summary.color}
            label={summary.label}
            sublabel={summary.sublabel}
            title={summary.title}
            emptyLabel="Scan Compliance"
        />
    );
}

export { ScanComplianceRing };
